import(/* webpackMode: "eager" */ "C:\\Users\\bigsa\\Desktop\\ShopAttend\\src\\app\\not-found.tsx");
